<template>
    <div class="agreement">
      <div class="title">
          <van-icon name="arrow-left" class="close" @click="close"/>
          交易购买协议
      </div>
      <div class="content">
          <div class="box">
            <p>1、付款成功后，联系客服提供交易平台账号、支付宝的扣款记录截图(需要显示订单编号的截图)</p>
            <p>2、付款成功后，官方在交予您的账号密码都是进行核实过后的，保证安全可靠。</p>
            <p>3、付款成功后，客服交予您账号与密码，只要您登陆账号成功，则视为交易成功，客服有权进行确认收货操作。(也可玩家自行确认，如客服没有及时确认，系统会在24小时内自动收货)</p>
            <p>4、交易成功后，并且买家已成功登陆账号则不再退货处理。</p>
            <p>5、交易成功后，平台安排账号或者角色过户。账号过户是指将出售方的账号资料备案成购买方的身份验证资料，该过程如同房屋交易买卖过户一样，有助于后期使用更安全。此外，交易完成的角色或者账号信息都是经过重置的，在后期使用上，您可以使用自己的个人资料信息对该账号进行官方服务业务的申请，能有效避免账号恶意找回的事件发生。</p>
            <p>6、交易成功后，因相关法案规定需配合客服进行游戏账号实名认证。</p>
            <p>7、成功付款后，买家单方取消交易，则需要支付平台50元人工服务费以及卖家对应档位的保证金提现手续费。</p>
            <p>8、成功付款，客服主动联系后，3个工作日内未有回复，系统将会自动判为交易成功。</p>
            <p>9、对于多次下单未付款/恶意下单影响商品正常出售的交易平台账号，平台将限制其交易平台账号下单购买商品。情形恶劣的，将封停交易平台账号。注:账号情况以交易平台显示截图为准，一旦买家登录成功，账号不退不换。账号购买成功后，将会转移至您指定的官方平台新账号下!</p>
          </div>
          <van-button color="var(--theme)" round class="agree_btn" @click="agree">同意协议并继续</van-button>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data () {
      return {
      }
    },
    computed: {},
    created () {},
    mounted () {},
    methods: {
      close() {
          this.$emit('handleClose')
      },
      agree() {
          this.$emit('handleSuccess')
      }
    },
    watch: {},
  }
  </script>
  
  <style lang="less" scoped>
  .agreement {
      height: calc(var(--vh,1vh)*100);
      background-color: var(--innerbgc);
      display: flex;
      flex-direction: column;
      .title {
          height: 5rem;
          line-height: 5rem;
          text-align: center;
          background: url(../../assets/version_1.3.0/index/linear.png) no-repeat 0 -3.7rem / 100% 26.2rem;
          color: #fff;
          font-size: 1.7rem;
          position: relative;
          .close {
              position: absolute;
              top: 50%;
              left: 1.8rem;
              transform: translateY(-50%);
              color: #fff;
              font-size: 1.8rem;
              cursor: pointer;
          }
      }
      .content {
          flex: 1;
          padding: 1.5rem 1rem;
          overflow-y: auto;
          .box {
              padding: 1.5rem 1rem;
              background-color: #fff;
              border-radius: 1rem;
              font-size: 1.4rem;
              color: #555;
              line-height: 1.8;
              h3 {
                  font-size: 1.6rem;
                  font-weight: normal;
                  margin: 1.2rem 0;
              }
          }
      }
      .agree_btn {
          display: block;
          width: 33.5rem;
          height: 5rem;
          margin: 1.5rem auto 2rem;
          font-size: 1.6rem;
      }
  }
  @media screen and (min-width: 525px) {
      .agreement {
          .title {
              .close {
                  left: 2rem;
              }
          }
      }
  }
  </style>
  